import React from 'react'
import { withIcon } from '../../withIcon'

function SidePanelIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M19.375 6C19.375 5.24061 18.7594 4.625 18 4.625H9.95801V19.375H18C18.7594 19.375 19.375 18.7594 19.375 18V6ZM4.625 18C4.625 18.7594 5.24061 19.375 6 19.375H8.70801V4.625H6C5.24061 4.625 4.625 5.24061 4.625 6V18ZM20.625 18C20.625 19.4497 19.4497 20.625 18 20.625H6C4.55025 20.625 3.375 19.4497 3.375 18V6C3.375 4.55025 4.55025 3.375 6 3.375H18C19.4497 3.375 20.625 4.55025 20.625 6V18Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SidePanelIcon)
